export default "__VITE_ASSET__CmBHGW4y__"